<kendo-grid-column [field]="field" [width]="width" [locked]="locked">
  <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
    <ng-container>
      <wlm-column-header-template [columnTitle]="column"></wlm-column-header-template>
    </ng-container>
  </ng-template>

  <ng-template kendoGridCellTemplate let-dataItem>
    <div
      class="cell-data"
      kendoTooltip
      [title]="(dataItem[field] ?? '') + ' ' + (dataItem[unitField] ?? '')"
    >
      {{ dataItem[field] | number : dataItem[formatField] ?? '1.0-0' | gridCellEmpty
      }}{{
        dataItem[field] && (dataItem[unitField] ?? '') !== '-'
          ? ' ' + (dataItem[unitField] ?? '')
          : ''
      }}
    </div>
  </ng-template>

  <ng-template
    kendoGridFilterMenuTemplate
    let-filter
    let-column="column"
    let-filterService="filterService"
  >
    <wlm-numeric-column-filter
      [field]="column.field"
      [filter]="filter"
      [filterService]="filterService"
    ></wlm-numeric-column-filter>
  </ng-template>
</kendo-grid-column>
